import styled from 'styled-components'

export const SubmitContainer = styled.div`
  width: 100%;
`

export const InputContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.125rem;
  width: 100%;
`

export const Text = styled.p`
  font-size: ${(props) => props.theme.font.textcaption};
  color: ${(props) => props.theme.color.purple.purple900};
  font-weight: 400;
  letter-spacing: 0.003rem;
`

export const Link = styled.div`
  font-size: ${(props) => props.theme.font.textoverline};
  color: ${(props) => props.theme.color.purple.purple900};
  font-weight: 400;
  cursor: pointer;
  outline: none;
  text-decoration: none;
`

export const CodeInput = styled.input`
  width: 100%;
  height: 100%;
  padding: 1.0625rem 0.875rem;
  border: none;
  border-radius: 0.25rem;
  border: 1px solid ${(props) => props.theme.color.blue.blue700};
  outline: none;
  background: ${(props) => props.theme.color.blue.blue50};
  color: ${(props) => props.theme.color.purple.purple900};
  font-size: ${(props) => props.theme.font.text2xl};
  font-weight: 500;
  letter-spacing: 0.42rem;
  text-align: center;
`

interface DisabledDivProps {
  isDisabled: boolean
}

export const DisabledDiv = styled.div<DisabledDivProps>`
  opacity: ${(props) => (props.isDisabled ? '0.2' : '1')};
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'all')};
`
